module.exports = __webpack_public_path__ + "img/1f4aa-1f3ff.49c310c.svg";